import { CheckOutlined, CloseOutlined, EditFilled } from '@ant-design/icons';
import Flag from 'react-flagpack';

import { Button, ErrorBoundary } from '../../../../components/index';
import { pilotFunctionList } from '../../../../utils/lists';

export function columns(onSelectItem: (item: any) => void) {
  return [
    {
      title: <div className="show-amount">Porto</div>,
      key: 'name',
      dataIndex: 'name',
    },
    {
      title: 'Trigrama',
      key: 'trigram',
      dataIndex: 'trigram',
    },
    {
      title: 'Bi Trigrama',
      key: 'bi_trigram',
      dataIndex: 'bi_trigram',
    },
    {
      title: 'País',
      key: 'country_name',
      dataIndex: 'country_name',
      render: (value: any, record: any) => {
        return (
          <>
            {record?.country_code && record?.country_code !== 'ANT' && (
              <ErrorBoundary replace="">
                <Flag code={record?.country_code} size="m" />
              </ErrorBoundary>
            )}
            <span> {value}</span>
          </>
        );
      },
    },
    {
      title: 'Ativo',
      key: 'archived_at',
      dataIndex: 'archived_at',
      render: (value: any, record: any) => {
        return value ? <CloseOutlined /> : <CheckOutlined />;
      },
    },
    {
      render: (_: any, record: any) => (
        <Button
          icon={<EditFilled />}
          style={{ float: 'right' }}
          onClick={() => onSelectItem(record)}
        />
      ),
    },
  ];
}
